var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.containerClass,attrs:{"type":"button"}},_vm.$listeners),[_c('span',{staticClass:"p-paginator-icon pi pi-step-forward"})])}
var staticRenderFns = []

export { render, staticRenderFns }